import { useIntl } from "react-intl";

import { Message } from "../../../../atoms/message";
import { LayoutGroup } from "../../../../form";
import { DateLayoutField } from "../../../../form/layout/fields/date-layout-field";
import { TextLayoutField } from "../../../../form/layout/fields/text-layout-field";
import { useDataFormPreferencesContext } from "../context";

export function DataTablePreferencesFormFields() {
  const intl = useIntl();

  const { mode } = useDataFormPreferencesContext();

  if (mode === "delete") {
    return (
      <div className="p-4">
        <Message variant="error">
          {intl.formatMessage({
            id: "data-table.preferences.delete.message",
            defaultMessage: "Přehled bude smazán. Tuhle akci nelze vrátit.",
          })}
        </Message>
      </div>
    );
  }

  if (mode === "apply") {
    return (
      <div className="p-4">
        <Message>
          {intl.formatMessage({
            id: "data-table.preferences.apply.message",
            defaultMessage: "Přehled bude nastaven ako aktuální.",
          })}
        </Message>
      </div>
    );
  }

  if (mode === "override") {
    return (
      <div className="p-4">
        <Message>
          {intl.formatMessage({
            id: "data-table.preferences.override.message",
            defaultMessage:
              "Nastavení přehledu budou přepsána aktuálními nastaveními tabulky",
          })}
        </Message>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 p-4">
      <LayoutGroup
        title={intl.formatMessage({
          id: "data-table.preferences-settings.fields.title",
          defaultMessage: "Základní informace",
        })}
      >
        <TextLayoutField name="id" label="Id" readOnly={true} />

        <TextLayoutField name="name" label="Název" required={true} />

        <DateLayoutField
          name="createdAt"
          label="Datum vytvoření"
          readOnly={true}
        />
      </LayoutGroup>
    </div>
  );
}
